import { render } from "./Headset.vue?vue&type=template&id=585f0238"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Headset.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "585f0238"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('585f0238', __exports__)) {
    api.reload('585f0238', __exports__)
  }
  
  module.hot.accept("./Headset.vue?vue&type=template&id=585f0238", () => {
    api.rerender('585f0238', render)
  })

}


export default __exports__